import { useCallback, useRef } from "react";

/**
 * Coordinates model save with form save so both are executed
 * when the user confirms changes in the modal's confirmation dialog.
 * Model deletions run first, then the form save callback fires.
 */
export const useModelSaveCoordination = (setOnSave?: (fn: () => void) => void) => {
  const modelSaveRef = useRef<(() => Promise<void>) | null>(null);
  const formSaveRef = useRef<(() => void) | null>(null);

  const registerModelSave = useCallback((fn: (() => Promise<void>) | null) => {
    modelSaveRef.current = fn;
  }, []);

  const wrappedSetOnSave = useCallback(
    (fn: () => void) => {
      formSaveRef.current = fn;
      setOnSave?.(async () => {
        await modelSaveRef.current?.();
        formSaveRef.current?.();
      });
    },
    [setOnSave]
  );

  return { registerModelSave, wrappedSetOnSave };
};
